import Transfer from '../../../assets/transfer.svg';

const TransferCallIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Transfer {...props} />;
};

export default TransferCallIcon;
